module.exports = __webpack_public_path__ + "static/media/7.a9c168f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/7.jpg
// module id = 598
// module chunks = 0